import * as graph from '@adc/sdk'
import { CombinedListingType } from 'common/context/listing'

// was bStatus.isPostPoned
export const isPostPoned = (listing: CombinedListingType) => {
  return [
    graph.enums.ListingStatus.Postponed,
    graph.enums.ListingStatus.PostponedPendingScheduling,
  ].includes(listing.listing_status)
}

// this was bStatus.isReAuctionPending, TPS online only
export const isReAuctionPending = (listing: CombinedListingType) => {
  return (
    listing.listing_status === graph.enums.ListingStatus.SaleFailed && // change this to sale failed, used to be NO SALE
    listing.listing_configuration?.asset_type ===
      graph.enums.AssetType.Foreclosure
  )
}

// this used to be bStatus.isAuctionSold, at first I was mapping it to segment status but there's a few cases we rely on this
// when we no longer have a segment so using listing_status_group === sold at the time of this comment
export const isAuctionSold = (listing: CombinedListingType) => {
  return listing.listing_status_group === graph.enums.ListingStatusGroup.Sold
}

export const formattedVenueAddress = (listing: CombinedListingType) => {
  // address formatting based off the logic in transformers.js
  const venueStreetUnit = listing.venue?.venue_address?.street_unit || ''
  const venueStreetNumber = listing.venue?.venue_address?.street_number || ''
  const venueStreetName = listing.venue?.venue_address?.street_name || ''
  const venueStreetAddress = `${venueStreetNumber} ${venueStreetName} ${venueStreetUnit}`
  const venueCity = listing.venue?.venue_address?.municipality || ''
  const venueState =
    listing.venue?.venue_address?.country_primary_subdivision || ''
  const venueZip = listing.venue?.venue_address?.postal_code || ''

  const formattedVenueAddress = `${venueStreetAddress}, ${venueCity}, ${venueState} ${venueZip}`

  return formattedVenueAddress
}
